<div class="account-header_wrapper mb-sm">
  <section class="account-header_content">
    <bw-header-legacy [title]="title | translate"></bw-header-legacy>
    <img *ngIf="imageUrl" [attr.src]="imageUrl" alt="partner-logo" />
  </section>
  <div class="account-header_balance mb-sm mt-sm">
    <typography-legacy text-xxlarge-semibold>{{ balance | currency }}</typography-legacy>
    <div class="account-header_balance-subsection flex-row space-between">
      <typography-legacy text-xsmall-regular color="var(--gray-50)">
        {{ 'ACCOUNT_HOME_CURRENT_BALANCE' | translate }}
      </typography-legacy>
      <ng-content select="[extra-details]"></ng-content>
    </div>
  </div>
  <ng-content select="[header-action-cards]"></ng-content>
</div>
